import { Input } from 'antd';
import styled from 'styled-components';
const { TextArea: AntTextArea } = Input;
export const MultiLineInput = styled(AntTextArea)`
  && {
    background: transparent;
    border: 0;
    border-bottom: solid 1px transparent;
    box-shadow: none;
    font-size: inherit;
    line-height: inherit;
    resize: none;
    transition: none;

    &:hover,
    &:focus {
      border-bottom-color: var(--border-color);
    }
  }

  :root[data-new-theme-enabled='true'] & {
    background: var(--white-100) !important;
    border: 1px solid var(--gray-10) !important;
    border-radius: var(--border-radius-small) !important;

    &:hover {
      border-color: var(--gray-20) !important;
    }
    &:focus {
      border: 2px solid var(--gray-20) !important;
    }
  }
`;
export const DefaultTextArea = styled(AntTextArea)``;
